import * as _4 from 'lodash4';

export interface ISettingsStateConfigObject {
  favorites?: string;
  notificationSettings?: string;
  topics?: string;
  intake?: string;
  firstTerm?: string;
}

export class SettingsStateConfigurationService {
  private _favorites: string;
  private _notificationSettings: string;
  private _topics: string;
  private _intake: string;
  private _firstTerm: string;

  constructor() {
    this._favorites = 'my.favorites';
    this._notificationSettings = 'my.notificationsettings';
    this._topics = 'my.updateTopics';
    this._intake = 'my.intake-poll';
    this._firstTerm = 'my.first-term-poll';
  }

  configure(configObj: ISettingsStateConfigObject) {
    _4.forEach(configObj, (val: string, key: string) => {
      if (!_4.isUndefined(this[key])) {
        this[key] = val;
      }
    });
  }

  set favorites(state: string) {
    this._favorites = state;
  }
  get favorites() {
    return this._favorites;
  }

  set notificationSettings(state: string) {
    this._notificationSettings = state;
  }
  get notificationSettings() {
    return this._notificationSettings;
  }

  set topics(state: string) {
    this._topics = state;
  }
  get topics() {
    return this._topics;
  }

  set intake(state: string) {
    this._intake = state;
  }
  get intake() {
    return this._intake;
  }

  set firstTerm(state: string) {
    this._firstTerm = state;
  }
  get firstTerm() {
    return this._firstTerm;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-settings/src/services/settings_state_configuration_service.ts